'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _renderFieldWithAddons = require('./../utils/renderFieldWithAddons');

var _renderFieldWithAddons2 = _interopRequireDefault(_renderFieldWithAddons);

var _Utils = require('./../Utils2');

require('./AbstractField.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstract field
 *
 * Základní komponenta každého input feildu
 *
 * Důvody:
 * - aby se dala později rozšířit o funkcionalitu
 * - pro renderování s addony
 */
var AbstractField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(AbstractField, _AbstractReactCompone);

    function AbstractField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AbstractField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AbstractField.__proto__ || (0, _getPrototypeOf2.default)(AbstractField)).call.apply(_ref, [this].concat(args))), _this), _this.renderFieldWithAddons = function (field, addonsBefore, addonsAfter) {
            return (0, _renderFieldWithAddons2.default)(field, addonsBefore, addonsAfter);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return AbstractField;
}(_AbstractReactComponent2.default);

AbstractField.PropTypes = {
    addonsBefore: _Utils.COMPONENT_CHILDREN,
    addonsAfter: _Utils.COMPONENT_CHILDREN
};
exports.default = AbstractField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvQWJzdHJhY3RGaWVsZC5qc3giXSwibmFtZXMiOlsiQWJzdHJhY3RGaWVsZCIsInJlbmRlckZpZWxkV2l0aEFkZG9ucyIsImZpZWxkIiwiYWRkb25zQmVmb3JlIiwiYWRkb25zQWZ0ZXIiLCJBYnN0cmFjdFJlYWN0Q29tcG9uZW50IiwiUHJvcFR5cGVzIiwiQ09NUE9ORU5UX0NISUxEUkVOIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7O0FBRUE7Ozs7QUFFQTs7Ozs7Ozs7O0lBU01BLGE7Ozs7Ozs7Ozs7Ozs7OzhOQU9GQyxxQixHQUF3QixVQUFDQyxLQUFELEVBQWdCQyxZQUFoQixFQUF5REMsV0FBekQsRUFBcUc7QUFDekgsbUJBQU8scUNBQWdCRixLQUFoQixFQUF1QkMsWUFBdkIsRUFBcUNDLFdBQXJDLENBQVA7QUFDSCxTOzs7O0VBVHVCQyxnQzs7QUFBdEJMLGEsQ0FFS00sUyxHQUFZO0FBQ2ZILGtCQUFjSSx5QkFEQztBQUVmSCxpQkFBYUc7QUFGRSxDO2tCQVNSUCxhIiwiZmlsZSI6IkFic3RyYWN0RmllbGQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBBYnN0cmFjdFJlYWN0Q29tcG9uZW50IGZyb20gJy4vLi4vQWJzdHJhY3RSZWFjdENvbXBvbmVudCdcbmltcG9ydCBmaWVsZFdpdGhBZGRvbnMgZnJvbSBcIi4vLi4vdXRpbHMvcmVuZGVyRmllbGRXaXRoQWRkb25zXCJcbmltcG9ydCB7Q09NUE9ORU5UX0NISUxEUkVOfSBmcm9tICcuLy4uL1V0aWxzMic7XG5cbmltcG9ydCBcIi4vQWJzdHJhY3RGaWVsZC5zY3NzXCJcblxuLyoqXG4gKiBBYnN0cmFjdCBmaWVsZFxuICpcbiAqIFrDoWtsYWRuw60ga29tcG9uZW50YSBrYcW+ZMOpaG8gaW5wdXQgZmVpbGR1XG4gKlxuICogRMWvdm9keTpcbiAqIC0gYWJ5IHNlIGRhbGEgcG96ZMSbamkgcm96xaHDrcWZaXQgbyBmdW5rY2lvbmFsaXR1XG4gKiAtIHBybyByZW5kZXJvdsOhbsOtIHMgYWRkb255XG4gKi9cbmNsYXNzIEFic3RyYWN0RmllbGQgZXh0ZW5kcyBBYnN0cmFjdFJlYWN0Q29tcG9uZW50IHtcblxuICAgIHN0YXRpYyBQcm9wVHlwZXMgPSB7XG4gICAgICAgIGFkZG9uc0JlZm9yZTogQ09NUE9ORU5UX0NISUxEUkVOLFxuICAgICAgICBhZGRvbnNBZnRlcjogQ09NUE9ORU5UX0NISUxEUkVOLFxuICAgIH07XG5cbiAgICByZW5kZXJGaWVsZFdpdGhBZGRvbnMgPSAoZmllbGQ6IE9iamVjdCwgYWRkb25zQmVmb3JlOiBbP09iamVjdCwgP0FycmF5PE9iamVjdD5dLCBhZGRvbnNBZnRlciA6IFs/T2JqZWN0LCA/QXJyYXk8T2JqZWN0Pl0pID0+IHtcbiAgICAgICAgcmV0dXJuIGZpZWxkV2l0aEFkZG9ucyhmaWVsZCwgYWRkb25zQmVmb3JlLCBhZGRvbnNBZnRlcik7XG4gICAgfVxufVxuZXhwb3J0IGRlZmF1bHQgQWJzdHJhY3RGaWVsZDtcbiJdfQ==